import { editProductApproach } from './restoreApproaches/editProduct';
import { shortLinkApproach } from './restoreApproaches/shortLink';

/**
 * restoreAdditionalServiceSubscriber содержит реализацию подписчика на
 * subject восстановления, который выполняется только один раз в случае
 * если ни один из вариантов восстановления не валиден или один из валиден.
 * Запускает активный способ восстановления. Снимает флаг восстановления,
 * если восстановленивать нечего.
 *
 * @param order
 * @param isNoRestoreNeed
 * @param langID
 * @param currencyID
 */
export const restoreAdditionalServiceSubscriber = async (
  restoreState: { type: 'order' | 'share'; data: any },
  isNoRestoreNeed: boolean,
  langID: string,
  currencyID: string
) => {
  if (isNoRestoreNeed) {
    return;
  }

  if (restoreState.type === 'share') {
    await shortLinkApproach(restoreState.data, langID, currencyID);
  } else if (restoreState.type === 'order') {
    await editProductApproach(restoreState.data, langID, currencyID);
  }
};
